// extracted by mini-css-extract-plugin
export var articleContents = "BlogPost-module--articleContents--9396c";
export var backLink = "BlogPost-module--backLink--c7d4d";
export var backLinkContainer = "BlogPost-module--backLinkContainer--40cd8";
export var center = "BlogPost-module--center--eb881";
export var container = "BlogPost-module--container--52e17";
export var decor = "BlogPost-module--decor--463fe";
export var left = "BlogPost-module--left--8dc1e";
export var newsAuthorBlock = "BlogPost-module--newsAuthorBlock--dc7fc";
export var newsFeatureMedia = "BlogPost-module--newsFeatureMedia--022ba";
export var newsHeader = "BlogPost-module--newsHeader--897b0";
export var quote = "BlogPost-module--quote--ee71e";
export var relativeWrapper = "BlogPost-module--relativeWrapper--7ac28";
export var right = "BlogPost-module--right--0a4e1";
export var wide = "BlogPost-module--wide--5eee4";